import { useStore } from "../../stores/StoreContext";
import { AiModelsService } from "../LogicServices/AiModelsService";

export function useAiModelsService(): AiModelsService {
  const storeContext = useStore();
  return new AiModelsService(storeContext);
}
